import React from 'react';

import { connect } from 'react-redux';

import { Button, Card, Col, message, Row } from 'antd';

import EnterpriseSelectionModal from './selection-modal';

import { toggleManagedUserEnterprisePermission, setManagedUserEnterprise } from '../user/actions';

import { 
	_postRemoveUserFromEnterprise,
	_postToggleFinancePermission, 
	_postToggleSuperuserPermission
} from '../../services';

class EnterpriseOverview extends React.Component{
	render(){

		let title;

		if(!this.props.enterpriseId){
			return (
				<Card title="Enterprise Manager">
					No enterprise assigned.
				</Card>
			)
		}


		title = this.props.enterprise && this.props.enterprise.companyName? this.props.enterprise.companyName : "Loading Enterprise Data..";

		// if( !this.props.enterprise ){
		// 	title = "Loading Enterprise Data..";
		// }

		return(
			<Card title={
				(
					<Row type="flex" align="middle" justify="space-between">
						<Col>
							{title}
						</Col>

						<Col>
							<Button
								onClick={ () => this.handleOnClickEditEnterprise() }>Edit</Button>
						</Col>
					</Row>
				)}>
				
				<strong>Users</strong>

				{this.props.isLive && this.props.enterprise && this.props.enterprise.users && this.props.enterprise.users.map(
					user => (
						<Row  style={{ marginBottom: 8 }} key={user.userId} type="flex" gutter={8} align="middle">
							
							<Col>{this.props.userMap[user.userId].local.email} </Col>

							<Col>
								<Row type="flex" justify="end" gutter={8}>

									<Col>
										
										<Button 
											type={ user.permission.superuser? 'primary': 'default' }	
											onClick={ () => this.handleOnClickSuperuserButton( user.userId ) }>
											Superuser
										</Button>
									</Col>

									<Col>
										
										<Button 
											type={ user.permission.finance? 'primary': 'default' }
											onClick={ () => this.handleOnClickFinanceButton( user.userId ) }>Finance</Button>
									</Col>

									<Col>
										<Button 	
											type="danger"
											onClick={ () => this.handleOnClickRemoveButton( user.userId ) } >Remove</Button>
									</Col>

								</Row>
							</Col>
							

						</Row>
					)
				)}

				{
					this.state.editEnterprise && (
						// <Modal visible={this.state.editEnterprise}>
						// 	<EnterpriseEditor 
						// 		enterprise={ this.props.enterprise }
						// 		invalidateField={ this.handleInvalidateEnterprise }
						// 		onChange={ this.handleOnChangeEnterprise }
						// 		onError={ this.handleOnError }
						// 		buttons={false} />						
						// 	</Modal>
						<EnterpriseSelectionModal 
							enterprise={this.props.enterprise} 
							onCancel={ this.handleOnClickCloseEnterpriseModal }
							visible={this.state.editEnterprise} /> 
					)
				}

			</Card>
		)
	}

	state = {
		editEnterprise: false
	}

	handleOnClickCloseEnterpriseModal = () => {
		this.setState({
			editEnterprise: false
		})
	}

	handleOnClickEditEnterprise = () => {
		this.setState({
			editEnterprise: true
		})
	}

	handleOnClickFinanceButton = ( userId ) => {
		
		const { enterpriseId } = this.props;

		_postToggleFinancePermission({ userId, enterpriseId })
			.then( res => {
				if( !res.data.success ){
					return message.error(res.data.message);
				}

				this.props.toggleManagedUserEnterprisePermission({
					permissionField: 'finance',
					userId
				});

			})
	}

	handleOnClickRemoveButton = ( userId ) => {
		const { enterpriseId, managedUserId } = this.props;

		_postRemoveUserFromEnterprise({ userId, enterpriseId })
			.then( res => {
				if( !res.data.success ){
					return message.error(res.data.message);
				}

				if( userId === managedUserId ){
					// refresh page
					window.location.reload();
				} else {
					
					const { enterprise, userMap } = res.data;

					this.props.setManagedUserEnterprise({ enterprise, userMap });
				}

				// this.props.toggleManagedUserEnterprisePermission({
				// 	permissionField: 'superuser',
				// 	userId
				// });

			})
	}

	handleOnClickSuperuserButton = ( userId ) => {
		const { enterpriseId } = this.props;

		_postToggleSuperuserPermission({ userId, enterpriseId })	
			.then( res => {
				if( !res.data.success ){
					return message.error(res.data.message);
				}

				this.props.toggleManagedUserEnterprisePermission({
					permissionField: 'superuser',
					userId
				});

			})
	}
}

export default connect(
	state => ({
		userMap: state.managedUser.isLive? state.managedUser.userMap: false,
		enterprise: state.managedUser.isLive? state.managedUser.data.enterprise: false,
		enterpriseId: state.managedUser.data.enterpriseId,
		isLive: state.managedUser.isLive,
		managedUserId: state.managedUser.data._id
	}),

	dispatchEvent => ({
		toggleManagedUserEnterprisePermission: ( toggleObj ) => dispatchEvent( toggleManagedUserEnterprisePermission( toggleObj ) ),
		setManagedUserEnterprise: ( enterpriseObj ) => dispatchEvent( setManagedUserEnterprise( enterpriseObj ) )
	})
)( EnterpriseOverview );


// WEBPACK FOOTER //
// ./src/components/enterprise/overview.js